export default function moderationEntryFilters(opts = {}) {
  let timeout;

  const debounce = (fn, ms) => {
    clearTimeout(timeout);
    timeout = setTimeout(fn, ms);
  };

  const allTopicInputs = Array.from(this.$refs.topicFilters.querySelectorAll('input[data-filter="topic"]'));
  const allTopics = allTopicInputs.map((input) => input.value);
  const allTagInputs = Array.from(this.$refs.tagFilters.querySelectorAll('input[data-filter="tag"]'));
  const allTags = allTagInputs.map((input) => input.value);

  return {
    showFilters: true,
    openTopics: false,
    openTags: false,
    defaultFilters: {
      ...opts,
      activeCount: 0,
    },
    filters: {
      ...opts,
      activeCount: 0,
    },

    init() {
      this.$watch(
        'filters',
        () => {
          this.$refs.checkAllTopics.checked = this.allTopicsSelected();
          this.$refs.checkAllTags.checked = this.allTagsSelected();
          this.setActiveFiltersCount();
          this.submitFilters();
        },
        { deep: true }
      );
    },

    // Topics
    toggleAllTopics() {
      if (this.allTopicsSelected()) {
        this.filters.topics = [];
      } else {
        this.filters.topics = allTopics;
      }
    },

    allTopicsSelected() {
      return allTopicInputs.every((input) => input.checked);
    },

    // Tags
    toggleAllTags() {
      if (this.allTagsSelected()) {
        this.filters.tags = [];
      } else {
        this.filters.tags = allTags;
      }
    },

    allTagsSelected() {
      return allTagInputs.every((input) => input.checked);
    },

    // Search
    clearSearch() {
      this.filters.q = '';
    },

    // Filters
    setActiveFiltersCount() {
      let count = 0;
      if (this.filters.publishStatus !== this.defaultFilters.publishStatus) count++;
      if (this.filters.moderationStatus !== this.defaultFilters.moderationStatus) count++;
      if (this.filters.q !== this.defaultFilters.q) count++;
      if (this.filters.topics.length > 0 && this.filters.topics.length !== allTopics.length) count++;
      if (this.filters.tags.length > 0) count++;
      this.filters.activeCount = count;
    },

    resetFilters() {
      this.showFilters = true;
      this.openTopics = false;
      this.openTags = false;
      this.filters = { ...this.defaultFilters };
    },

    submitFilters() {
      this.setActiveFiltersCount();
      debounce(() => {
        this.$root.requestSubmit();
      }, 550);
    },

    reset: {
      ['x-on:click.prevent.stop']() {
        this.resetFilters();
      },
      ['x-transition:enter']() {
        return 'transition ease-out duration-100';
      },
      ['x-transition:enter-start']() {
        return 'transform opacity-0 scale-95';
      },
      ['x-transition:enter-end']() {
        return 'transform opacity-100 scale-100';
      },
      ['x-transition:leave']() {
        return 'transition ease-in duration-75';
      },
      ['x-transition:leave-start']() {
        return 'transform opacity-100 scale-100';
      },
      ['x-transition:leave-end']() {
        return 'transform opacity-0 scale-95';
      },
    },
  };
}
